class ScrollSpy {

    //
    constructor(menuSelector, sectionSelector) {
        this.menuItems = document.querySelectorAll(menuSelector);
        this.sections = document.querySelectorAll(sectionSelector);
        this.init();
    }

    //
    init() {

        //
        const options = {
            root: null,
            rootMargin: '120px',
            threshold: 0.7
        };

        //
        const observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
        this.sections.forEach(section => observer.observe(section));
    }

    //
    handleIntersection(entries) {

        //
        entries.forEach(entry => {

            //
            if (entry.isIntersecting) {
                const targetName = entry.target.name;
                this.setActiveMenuItem(targetName);
            }

        });

    }

    //
    setActiveMenuItem(targetName) {

        //
        this.menuItems.forEach(item => {

            //
            item.classList.remove('active');

            //
            if (this.getHref(item) === `#${targetName}`) {
                item.classList.add('active');
            }

        });

    }

    //
    enableSmoothScroll() {

        //
        this.menuItems.forEach(link => {

            //
            link.addEventListener('click', (event) => {

                //
                const href = this.getHref(link);
    
                //
                if (href.startsWith('#')) {

                    //
                    event.preventDefault();

                    //
                    const targetName = href.substring(1);
                    const targetElement = document.querySelector(`a[name="${targetName}"]`);
                    
                    //
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }

                }

            });

        });

    }

    //
    getHref(element) {

        //
        let href = '';
        let anchor =  '';

        //
        if (href = element.getAttribute('href')) {
            return href;
        }

        //
        if (anchor = element.querySelector('a')) {
            href = anchor.getAttribute('href');
        }

        //
        return href;

    }
}

//
module.exports = ScrollSpy;